import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Wallet, TrendingDown, Users2, TrendingUp, History, Percent, Rocket } from "lucide-react";
import FinanzasComisionesPage from "@/pages/FinanzasComisionesPage";
import GastosMensualesPage from "@/pages/GastosMensualesPage";
import SociosPage from "@/pages/SociosPage";
import RentabilidadPage from "@/pages/RentabilidadPage";
import HistorialSociosPage from "@/pages/HistorialSociosPage";
import CrecimientoPage from "@/pages/CrecimientoPage";

const TABS = [
  { key: "gastos", label: "Gastos mensuales", icon: TrendingDown, Component: GastosMensualesPage, testid: "tab-gastos" },
  { key: "rentabilidad", label: "Rentabilidad", icon: TrendingUp, Component: RentabilidadPage, testid: "tab-rentabilidad" },
  { key: "crecimiento", label: "Crecimiento", icon: Rocket, Component: CrecimientoPage, testid: "tab-crecimiento" },
  { key: "comisiones", label: "Comisiones", icon: Percent, Component: FinanzasComisionesPage, testid: "tab-comisiones" },
  { key: "socios", label: "Socios", icon: Users2, Component: SociosPage, testid: "tab-socios" },
  { key: "historial", label: "Historial sociedad", icon: History, Component: HistorialSociosPage, testid: "tab-historial" },
];

export default function FinanzasHubPage() {
  const [tab, setTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("tab") || "gastos";
  });
  // Nov/2026: si la URL cambia (KPI → /finanzas?tab=x estando ya en el hub), seguir el tab
  const _loc = useLocation();
  useEffect(() => {
    const t = new URLSearchParams(_loc.search).get("tab");
    if (t && t !== tab) setTab(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_loc.search]);
  const setTabAndUrl = (t) => {
    setTab(t);
    const url = new URL(window.location);
    url.searchParams.set("tab", t);
    window.history.replaceState({}, "", url);
  };
  const Active = TABS.find((t) => t.key === tab) || TABS[0];

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-4xl font-display font-bold text-foreground flex items-center gap-3">
          <Wallet className="w-8 h-8 text-primary" /> Finanzas
        </h1>
      </header>

      <div className="flex gap-1 mb-6 border-b border-border overflow-x-auto">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTabAndUrl(t.key)}
            className={`px-4 py-3 text-sm font-semibold border-b-2 transition-all flex items-center gap-2 whitespace-nowrap ${
              tab === t.key ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
            data-testid={t.testid}
          >
            <t.icon className="w-4 h-4" /> {t.label}
          </button>
        ))}
      </div>

      <div className="hub-embedded hub-embedded-sub"><Active.Component embedded={true} /></div>
    </div>
  );
}
